import React from 'react';
import {getPaymentStatusConfig} from './StoreStatusConfig';

interface StorePaymentStatusBadgeProps {
  status: string | undefined | null;
}

export const StorePaymentStatusBadge: React.FC<StorePaymentStatusBadgeProps> = ({
  status
}) => {
  const {statusConfig, statusText, tooltip} = getPaymentStatusConfig(status);

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${statusConfig.className} cursor-help`}
      title={tooltip}
    >
      {statusText}
    </span>
  );
};
